import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { http, apiError, TOKEN_KEY } from "../lib/api";
import { Logo } from "../components/site/Logo";
import { Input } from "../components/ui/input";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      nav("/admin");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative grid min-h-screen place-items-center overflow-hidden bg-cream px-5" data-testid="admin-login-page">
      <img src="/images/ftl.png" alt="" aria-hidden="true" className="pointer-events-none absolute -left-16 -top-16 w-72 opacity-80" />
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-[28px] border border-gold/25 bg-white p-8 shadow-xl" data-testid="admin-login-form">
        <Link to="/" className="inline-block"><Logo /></Link>
        <h1 className="mt-8 flex items-center gap-2 font-serif text-3xl text-ink"><Lock className="h-5 w-5 text-gold" /> Studio login</h1>
        <p className="mt-1 text-sm text-ink-soft">Manage inquiries, prices and gallery.</p>
        <div className="mt-7 space-y-4">
          <Input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="admin-email-input" />
          <Input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" data-testid="admin-password-input" />
        </div>
        {error && <p className="mt-4 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-gold mt-6 w-full" data-testid="admin-login-btn">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
